export default {
  notifications: 'お知らせ',
  no_unread_notification: '未読の通知なし',
  see_all_notification: 'すべての通知を見る',
  see_all: 'すべてを見る'
}
